import { X, Pin, AppWindow, Button, Maximize2, PinOff } from "@repo/ui";
import { cn } from "@repo/utils";

type Props = {
  id: string;
  title: string;
  isPinned: boolean;
  onPin: (id: string, isPinned: boolean) => void;
  onClose: (id: string) => void;
  onMaximize: (id: string) => void;
};

export const TaskExplorerMinimizedWindow = ({
  id,
  isPinned,
  onPin,
  onMaximize,
  onClose,
  title,
}: Props) => {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={() => onMaximize(id)}
      className="group hover:bg-gxe-bg-gray flex cursor-pointer items-center justify-between gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2 shadow-sm transition-all hover:shadow-md"
    >
      <div className="flex items-center gap-1">
        <Button
          icon={<X className="h-4 w-4" />}
          variant="outline"
          align="center"
          justify="center"
          onClick={(e) => {
            e.stopPropagation();
            onClose(id);
          }}
          title="Close"
        />
        <Button
          icon={<Maximize2 className="h-4 w-4" />}
          variant="outline"
          align="center"
          justify="center"
          onClick={(e) => {
            e.stopPropagation();
            onMaximize(id);
          }}
          className="rounded-full"
          title={"Maximize"}
        />
        <Button
          icon={<AppWindow className="h-4 w-4" />}
          variant="outline"
          align="center"
          justify="center"
          className="rounded-full"
          title="Open as window"
        />
        <Button
          icon={isPinned ? <PinOff className="h-4 w-4" /> : <Pin className="h-4 w-4" />}
          variant={isPinned ? "secondary" : "outline"}
          align="center"
          justify="center"
          onClick={(e) => {
            e.stopPropagation();
            onPin(id, !isPinned);
          }}
          className="rounded-full"
          title={isPinned ? "Unpin" : "Pin"}
        />
      </div>
      <span
        className={cn("mx-2 text-left text-sm font-medium", {
          "text-gxe-primary": isPinned,
          "text-gray-700": !isPinned,
        })}
      >
        {title}
      </span>
    </div>
  );
};
